import request from '@/utils/request'

export function read(query) {
  return request({
    url:"/websocket/websocket/read",
    method: 'get',
    params: query
  })
}
